module.exports = __webpack_public_path__ + "images/home/product/features-statistic-8af360fb01bf755b03b3a9484c0f43c5.png";